// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".displayFlex[data-v-aa5372b2]{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
